<template>
  <md-card-actions>
    <md-button class="md-primary md-sm" @click="backToQuoteItems()">
      <span class="md-label">
        <md-icon class="material-icons">keyboard_backspace</md-icon> </span
      >View other Quotes
    </md-button>
    <md-button
      v-if="setVisibility(1)"
      class="md-warning md-sm"
      @click="reissueQuote()"
    >
      <span class="md-label">
        <md-icon class="material-icons">{{ quoteIcon }}</md-icon>
      </span>
      Reissue Quote
    </md-button>
    <status-button
      :statusId="4"
      :classColour="quoteStatus(4).colour"
      icon="check"
      :text="quoteStatus(4).name"
      :visible="setVisibility(4)"
      :role="100"
      @change-status="changeStatus"
    ></status-button>
    <status-button
      :statusId="5"
      :classColour="quoteStatus(5).colour"
      icon="check"
      :text="quoteStatus(5).name"
      :visible="setVisibility(5)"
      :role="100"
      @change-status="changeStatus"
    ></status-button>
  </md-card-actions>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "quote-actions",
  computed: {
    ...mapGetters({
      quote: "quote/quote",
      quoteStatus: "quote/getQuoteStatus",
      quoteIcon: "quote/icon"
    })
  },
  methods: {
    changeStatus(statusId) {
      this.$emit("change-status", statusId);
    },
    reissueQuote() {
      this.$router.push({
        name: "Reissue Quote",
        params: { quoteId: this.$route.params.quoteId }
      });
    },
    backToQuoteItems() {
      this.$router.push({
        name: this.quoteStatus(this.quote.quoteStatus).list
      });
    },
    setVisibility(statusId) {
      switch (statusId) {
        case 1:
          return this.quote.quoteStatus > 5;
        case 2:
          return this.quote.quoteStatus === 1;
        case 3:
          return this.quote.quoteStatus === 2;
        case 4:
          return this.quote.quoteStatus === 3;
        case 5:
          return this.quote.quoteStatus === 4;
        case 6:
          return this.quote.quoteStatus == 1;
        case 7:
          return this.quote.quoteStatus == 2;
      }
    }
  }
};
</script>

<style></style>
